<template>
  <div class="max-w-5xl p-4 md:px-16 md:py-8 mx-auto sm:bg-white sm:border sm:rounded">
    <div class="max-w-4xl mx-auto text-center">

      <p class="font-bold text-xl p-4 rounded bg-orange-300">
        Notice: It is recommended that you use the Google Chrome Browser.<br><a href="https://www.google.com/chrome/" target="_blank" class="link">Click here to download.</a></p>
      <p class="text-xl font-light mt-6">Below are a few video that go over some of the app functionality. If these don't answer your question or help solve your probmen you can send an email to <span class="font-bold">{{supportEmail}}</span> and I am happy to help you out. </p>
    </div>
    <div class="text-center max-w-2xl mx-auto mt-6">
      <h1 class="mb-6">Showman Screencasts</h1>

      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Entry Overview</h2>
        <div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/330855654' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <p>A detailed example of how the online entry system works</p>
      </div>
      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Creating your Account</h2>
        <div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/330909150' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <p>An overview of how to create your account for Showman</p>
      </div>
      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Navigating Within Showman</h2>
        <div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/330907675' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <p>A brief overview of navigating within Showman</p>
      </div>
      <h2 class="mt-16 text-4xl mb-4">Admin Videos</h2>
      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Check In</h2>
        <div class="flex justify-center mb-4">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/h3WlDI668Xg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <p>A brief overview on how to check in the exhibitors.</p>
      </div>
      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Show Books (Preset Classes)</h2>
        <div class="flex justify-center mb-4">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/00Mf5HAwvrA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <p>A brief overview on how the show books work and how to manually create the class breaks by weight or age if needed.</p>
      </div>
      <div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Printing</h2>
        <div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/381575365' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <p>A brief overview of how to customize and print out class lists and result books.</p>
      </div>
      <!--<div class="mb-10">
        <h2 class="mb-2 text-3xl font-light">Mail In Entries</h2>
        <div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/362355052' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <p>A brief overview on adding mail in entries</p>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      supportEmail: process.env.VUE_APP_SUPPORT_EMAIL
    }
  }
}
</script>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0; overflow: hidden;
  max-width: 100%;
}
.embed-container iframe, .embed-container object, .embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  }
</style>
